function isRepeatPurchaser(orderCount, isGuest) {
    if (isGuest) return 'NonShopper';
    if (orderCount > 0) return 'Repeat';

    return 'New';
}

/**
 * Maps attributes with sensitive information that can identify a user
 */
module.exports = function (data) {
    return {
        user: {
            segment: undefined, // Important: This information is set in the Dynamic Tag Manager.
            status: data.shopperDetails.ShopperStatusId,
            userType: data.shopperDetails.ABN && data.shopperDetails.ABN !== '' ? 'Business' : 'Personal',
            newRepeatPurchase: isRepeatPurchaser(data.shopperDetails.OrderCount, data.shopperDetails.IsGuest),
            sapCategory: '',
            lifeStage: '',
            profile: {
                profileInfo: {
                    shopperID: data.shopperDetails.Id,
                    userName: data.shopperDetails.Email,
                },
                personalDetails: {
                    firstName: data.shopperDetails.FirstName,
                    lastName: data.shopperDetails.LastName,
                    DOB: data.shopperDetails.DateOfBirthInput,
                    email: data.shopperDetails.Email,
                    preferredContactNumber: data.shopperDetails.Phone,
                    secondaryPhone: data.shopperDetails.SecondaryPhone,
                    age: data.shopperDetails.Age,
                },
                businessDetails: {
                    companyName: data.shopperDetails.CompanyName,
                    ABN: data.shopperDetails.ABN,
                    typeOfBusiness: data.shopperDetails.TypeOfBusiness,
                    jobTitle: data.shopperDetails.JobTitle,
                },
                attributes: {
                    EDR: !data.shopperDetails.RewardsCardNumber || data.shopperDetails.RewardsCardNumber === '' ? 'No' : 'Yes',
                    orderCount: data.shopperDetails.OrderCount,
                    deliverySaverExpiryDate: data.shopperDetails.ActiveDeliverySaverExpiryDate,
                    emailOptIn: data.shopperDetails.EmailOptIn,
                    emailWidgetOptIn: data.shopperDetails.EmailWidgetOptIn,
                    CRN: data.shopperDetails.Crn,
                },
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/auth/shopper/analytics/shopper-profile-pii-analytics-dtm-mapper.js